import React from "react";
import styles from "./OfferM.module.css";

export default function Offer() {
  return <div className={styles.sectionContent}>
      <div className={styles.offer}>
        <p>
          {"Promocja".toUpperCase()}! Wymień olej silnikowy w naszym warsztacie i dostań 10% {"zniżki".toUpperCase()} na wymianę opon w naszej wulkanizacji.
        </p>
        <p>
          {"Promocja".toUpperCase()}! Wymień olej silnikowy w naszym warsztacie i dostań 10% {"zniżki".toUpperCase()} na wymianę opon w naszej wulkanizacji.
        </p>
        <p>
          {"Promocja".toUpperCase()}! Wymień olej silnikowy w naszym warsztacie i dostań 10% {"zniżki".toUpperCase()} na wymianę opon w naszej wulkanizacji.
        </p>
      </div>
    </div>;
}
